import { render } from "./PersonInfoToast.vue?vue&type=template&id=35b57e16&scoped=true&ts=true"
import script from "./PersonInfoToast.vue?vue&type=script&lang=ts"
export * from "./PersonInfoToast.vue?vue&type=script&lang=ts"

import "./PersonInfoToast.vue?vue&type=style&index=0&id=35b57e16&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b57e16"]])

export default __exports__